import StateObserver from './StateObserver';

const DiscoveryObserver = {
  install(Vue) {
    Vue.prototype.discoveryObserver = new StateObserver();
  },
};

export default DiscoveryObserver;
